/**
 * Export Status
 * 0 = Pending
 * 1 = Processing
 * 2 = Completed
 * 3 = Failed
 */
export enum ExportStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export interface ExportJob {
  id: string;
  entityType: string;
  status: ExportStatus;
  message: string;
  createdDateTime: string;
  completedDateTime: string | null;
  startedDateTime: string | null;
  fileSize: number | null;
  fileName: string;
  isReady: boolean;
  isFailed: boolean;
  isProcessing: boolean;
}

export interface CreateExportRequest {
  entityType: string;
  filter: {
    filters: any[];
    sort: any[];
  };
}
